import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const ProductDetailsTable = ({ productData }) => {
  const [loadinga, setLoadinga] = useState(false);

  
  return (
    <>
      {loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box>
            {/* heading */}
            <Box
              sx={{
                boxShadow: "none",
                outline: "none",
                mb: "10px",
                border: "none",
                mt: "10px",
                boxSizing: "border-box",
              }}
            >
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",

                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      #
                    </Typography>
                  </Paper>
                </Grid>
                {/* Second Column */}
                <Grid item xs={2} md={2}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      Photo
                    </Typography>
                  </Paper>
                </Grid>
                {/* Third Column */}
                <Grid item xs={3} md={3}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      Product ID
                    </Typography>
                  </Paper>
                </Grid>
                {/* Fourth Column */}
                <Grid item xs={3} md={3}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      Product Name
                    </Typography>
                  </Paper>
                </Grid>
                {/* fifth Column */}
                <Grid item xs={2} md={2}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      Price
                    </Typography>
                  </Paper>
                </Grid>
                {/* Sixth Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        opacity: "45%",
                        color: "#252525",
                      }}
                    >
                      Quantity
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                border: "1px solid #DDDDDD",
                height: "100%",
                overflow: "auto",
                "&:hover": {
                  "::-webkit-scrollbar": {
                    width: "5px",
                    borderRadius: "10px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    bgcolor: "gray",
                    borderRadius: "10px",
                  },
                },
                mt: "10px",
                borderTop: "0.5px solid #DDDDDD",
                maxHeight: "75vh",
              }}
            >
              <Box>
                <Grid container>
                  {/* first column */}
                  <Grid item xs={0.5} md={0.5}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column1 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                          }}
                        >
                          {i + 1}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Second Column */}
                  <Grid item xs={2} md={2}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column2 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <img
                          width={"51px"}
                          height={"51px"}
                          style={{ borderRadius: "10px" }}
                          src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${item?.product_image}`}
                          alt="pic"
                        />
                      </Paper>
                    ))}
                  </Grid>
                  {/* Third Column */}
                  <Grid item xs={3} md={3}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column3 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            color: "#252525",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.product_id}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Fourth Column */}
                  <Grid item xs={3} md={3}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column4 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          noWrap
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.product_name}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* fifth Column */}
                  <Grid item xs={2} md={2}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column5 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",

                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {productData?.products_details[i]?.actual_price}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Sixth Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.products_details?.map((item, i) => (
                      <Paper
                        key={`column6 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {productData?.products_details[i]?.quntity}
                        </Typography>
                      </Paper>
                    ))}{" "}
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ProductDetailsTable;
